import './style.scss'
import { useContext, useState } from 'react'
import utility from 'src/utils/utility'
import { useNavigate } from 'react-router-dom'
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppLink, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, GridContainer } from 'src/style'
import { WelcomeFrame } from 'src/component'
import { IoChevronBackOutline } from 'react-icons/io5'
import { OtpLogin } from 'src/popup'

const SignIn: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({username: '', password: ''})
    const [isOtp, setIsOtp] = useState(false)

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleLogin (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const response = await API.login(input)
        if (response) setIsOtp(true)
    }

    return (
        <>
            <FlexRow 
                height='100' hUnit='%' topPadding='1.5' width='100' 
                sizeUnit='%' justifyContent='flex-start'
                bottomPadding='1.5' leftPadding='1' rightPadding='1'
            >
                <WelcomeFrame />
                <FlexColumn 
                    height='100' hUnit='%' width='63'
                    sizeUnit='%' radius='0.8'
                    leftPadding='4' rightPadding='4'
                    className='admin-types-block'
                >
                    <AbsoluteContainer top='0' right='6'>
                        <AppLink 
                            decoration='none' color='#101225' textSize='1.2' hoverColor='#4C6FFF'
                            style={{backgroundColor: '#FAFAFA'}}
                        >
                            User type selected
                        </AppLink>
                    </AbsoluteContainer>
                    <AbsoluteContainer bottom='0' left='6'>
                        <AppLink 
                            decoration='none' color='#425466' textSize='1' fontWeight='600'
                            style={{backgroundColor: '#FAFAFA'}}
                        >
                            Crendly support panel 2022
                        </AppLink>
                    </AbsoluteContainer>

                    <FlexRow alignItems='flex-start' width='auto' sizeUnit=''>
                        <GridContainer 
                            height='3' width='3.2' borderColor=' #E4ECF7' 
                            radius='0.4' rightMargin='4'
                            onClick={() => navigate(-1)}
                        >
                            <IoChevronBackOutline className='back-icon' />
                        </GridContainer>
                        <CustomContainer 
                            width='52' minHeight='60' bgColor='#ffffff'
                            borderColor='#E2E8F0' radius='0.8' topPadding='3'
                            bottomPadding='3' rightPadding='4.5' leftPadding='4.5'
                            className='login-container'
                        >
                            <AppText color='#27272E' textSize='2.8' fontWeight='600' align='center' bottomMargin='1'>Sign in</AppText>
                            <AppText color=' #27272E' textSize='1.6' align='center' >Let's continue the good work</AppText>
                            <Form topMargin='6' onSubmit={handleLogin}>
                                <FormGroup>
                                    <label>E-mail or phone number</label>
                                    <input 
                                        placeholder='Type your e-mail or phone number'
                                        name='username'
                                        onChange={handleInput}
                                        required
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <label>Password</label>
                                    <input 
                                        type='password'
                                        placeholder='Type your password'
                                        name='password'
                                        onChange={handleInput}
                                        required
                                    />
                                    <AppText color='#718096' textSize='1.1' topMargin='0.7'>Must be 8 characters at least</AppText>
                                </FormGroup>
                                <Button
                                    width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                                    hoverBgColor='#ffffff' hoverColor='#4C6FFF' bottomMargin='2.5'
                                >
                                    Sign in
                                </Button>
                                <AppLink 
                                    decoration='none' color='#4C6FFF' textSize='1.2' 
                                    fontWeight='600' hoverColor='#425466'
                                    onClick={() => navigate('/forgetpassword/identification')}
                                >
                                    Forgot Password?
                                </AppLink>
                            </Form>
                        </CustomContainer>
                    </FlexRow>
                </FlexColumn>
            </FlexRow>
            { isOtp &&
                <OtpLogin
                    close={() => setIsOtp(false)}
                />
            }
        </>
    )
}

export default utility.routeData('login', 'Sign In', <SignIn/>)